<div class="flex flex-col flex-auto">
  <!-- Form -->
  <!-- AB#60317 — canSendComment hides the composer once the optional maxComments cap is reached. -->
  <form *ngIf="showInput && canSendComment" [formGroup]="chatForm" class="print:hidden">
    <div 
      class="flex items-start pb-3" 
      [ngClass]="{
        'pb-6 -mt-4 pl-10 w-[calc(100%+1rem)]': smallSize && isChild,
        'gap-2': smallSize,
        'gap-10': !smallSize
      }"
    >
      <div class="flex flex-col flex-auto min-w-0"
        [ngClass]="{
          'w-[calc(100%-76px)]': !isChild && smallSize && attachmentFiles?.length,
          'w-[calc(100%-48px)]': isChild && smallSize && attachmentFiles?.length
        }"
      >
        <svc-comments-input
          #commentInput
          [placeholder]="placeholder | transloco"
          [control]="chatForm.controls.message"
          [loading]="isCreatingCommentLoading"
          [buttonDisabled]="!commentIsValidToSend"
          [hideSendButton]="hideSendButton"
          (onButtonClicked)="sendMessage()"
        />
        <div class="flex flex-wrap" 
          [ngClass]="{
            'w-[calc(100%+40px)]': smallSize && isChild,
            'w-[calc(100%+76px)]': smallSize && !isChild
          }"
        >
          <div class="attachment-item text-default" *ngFor="let attachment of attachmentFiles" [ngClass]="{ 'w-full mr-0': smallSize }">
            @if (attachment.type !== AttachmentFileType.RECORDED_AUDIO) {
              <div class="attachment-file">
                <mat-icon class="text-current icon-size-4" svgIcon="mat_solid:attach_file"/>
              </div>
            }
            <div class="attachment-content">
              @if (attachment.type === AttachmentFileType.RECORDED_AUDIO) {
                <audio controls [ngClass]="{ 'w-full': smallSize }">
                  <source [src]="attachment.file | blobToUrl">
                </audio>
              }
              @else {
                <span>{{ attachment.file.name }}</span>
              }
            </div>
            <div class="attachment-remove">
              <mat-icon
                class="text-current icon-size-4 cursor-pointer"
                svgIcon="mat_solid:close"
                [matTooltip]="'Remover' | transloco"
                (click)="removeAttachment(attachment.file)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="flex" [ngClass]="smallSize ? 'gap-1' : 'gap-2.5'">
        @if (!isChild || !smallSize) {
          <button
            svc-filled-btn-icon
            type="button"
            class="mt-2 rounded-full"
            icon="mat_solid:attach_file"
            iconSize="6"
            [color]="isCreatingCommentLoading ? 'text' : 'primary'" 
            [class]="smallSize ? null : 'w-10 h-10 max-w-none max-h-none'"
            [disabled]="isCreatingCommentLoading"
            (click)="!isCreatingCommentLoading && openAttachmentWindow()"
          ></button>
        }

        <svc-audio-to-text-button
          #audioToText
          class="mt-2"
          [class.block]="!isChild || !smallSize"
          [class.hidden]="isChild && smallSize"
          [small]="smallSize"
          [disabled]="isCreatingCommentLoading"
          [canChooseRecording]="true"
          (onText)="chatForm.controls.message.setValue($event)"
          (onAudioRecorded)="addFileToAttachments($event.file, AttachmentFileType.RECORDED_AUDIO)"
        />

        @if (isChild && smallSize) {
          <button
            svc-filled-btn-icon
            type="button" 
            iconSize="6"
            class="mt-2 rounded-full"
            [icon]="(!audioToText.loading && audioToText.step == 'RECORDING') ? 'mat_solid:stop' : 'heroicons_solid:ellipsis-vertical'"
            [color]="isCreatingCommentLoading ? 'text' : 'primary'" 
            [class]="smallSize ? null : 'w-10 h-10 max-w-none max-h-none'" 
            [disabled]="isCreatingCommentLoading"
            [matMenuTriggerFor]="(!isCreatingCommentLoading &&!audioToText.isRecording && audioToText.canChooseRecording) ? matMenu : null"
            (click)="!isCreatingCommentLoading && (audioToText.isRecording ? audioToText.recordAudio() : (!audioToText.canChooseRecording && audioToText.recordAudio(ActionType.AUDIO_TO_TEXT)))"
          ></button>
        }

        <mat-menu #matMenu xPosition="before">
          <button mat-menu-item (click)="openAttachmentWindow()">
            <mat-icon svgIcon="mat_solid:attach_file" class="icon-size-4 text-default"/>

            <p class="text-default">
              {{ 'Anexar' | transloco }}
            </p>
          </button>

          <button mat-menu-item (click)="audioToText.recordAudio(actionType.RECORD_AUDIO)">
            <mat-icon svgIcon="heroicons_solid:microphone" class="icon-size-4 text-default"/>

            <p class="text-default">
              {{ 'Gravar áudio' | transloco }}
            </p>
          </button>

          <button mat-menu-item (click)="audioToText.recordAudio(actionType.AUDIO_TO_TEXT)">
            <mat-icon svgIcon="heroicons_solid:microphone" class="icon-size-4 text-default"/>

            <p class="text=default">
              {{ 'Voz para texto' | transloco }}
            </p>
          </button>
        </mat-menu>
      </div>
    </div>
  </form>

  <!-- Messages -->
  <div 
    class="flex flex-col flex-auto w-full" 
    [ngClass]="{
      'px-4': smallSize && !isChild,
      'px-0': smallSize && isChild,
      'pl-4': !smallSize && !isChild
    }"
  >
    <svc-comments-message
      *ngFor="let message of messages"
      [class]="smallSize ? 'pb-6' : 'pb-4'"
      [message]="message"
      [configTypeId]="configTypeId"
      [parentMessage]="parentMessage"
      [applicationId]="applicationId"
      [smallSize]="smallSize"
      [siteId]="siteId"
      [external]="external"
      [parentApplicationId]="parentApplicationId"
      [parentRegisterId]="parentRegisterId"
      [parentRegisterUId]="parentRegisterUId"
      [parentOriginatorId]="parentOriginatorId"
      [parentRegisterCode]="parentRegisterCode"
      [parentRegistryCode]="parentRegistryCode"
      [fromFeed]="fromFeed"
      (onCommentRemoved)="commentRemoved($event)"
      (onCommentAdded)="onCommentAdded.emit($event)"
    />
  </div>

  @if (!messagesAreGone) {
    <div class="flex pb-2 print:hidden" [class.justify-center]="!isChild || isLoading" [class.my-2]="isLoading">
      @if (!isLoading) {
        <button svc-btn (click)="nextPage()">
          {{ (isChild ? 'Carregar mais respostas' : 'Carregar mais comentários') | transloco }}
        </button>
      }
      @else {
        <mat-spinner class="text-primary" diameter="24"/>
      }
    </div>
  }
</div>
